import {
  Event,
  ExternalSearchResult,
  Member,
  Post,
  Space,
} from '@tribeplatform/gql-client/types'

import { HistoryItem } from '../index.js'
import {
  ExtendedSmartSearchEntity,
  ExtendedSmartSearchEntityType,
} from '../SmartSearch.types.js'

type getSearchItemURLProps = {
  entityType: ExtendedSmartSearchEntityType
  item: ExtendedSmartSearchEntity
}

export const getSearchItemURL = ({
  entityType,
  item,
}: getSearchItemURLProps): string => {
  switch (entityType) {
    case ExtendedSmartSearchEntityType.MEMBERS: {
      const member = item as Member
      return member.relativeUrl || `/member/${member.id}`
    }
    case ExtendedSmartSearchEntityType.SPACES: {
      const space = item as Space
      return space.relativeUrl || `/${space.address?.path || space.slug}`
    }
    case ExtendedSmartSearchEntityType.OFFICIAL_POSTS:
    case ExtendedSmartSearchEntityType.POSTS: {
      const post = item as Post
      return (
        post.relativeUrl ||
        `/${post.space?.address?.path || post.space?.slug}/post/${post.id}`
      )
    }
    case ExtendedSmartSearchEntityType.EXTERNALS: {
      const external = item as ExternalSearchResult
      return external.url
    }
    case ExtendedSmartSearchEntityType.HISTORY: {
      const history = item as HistoryItem
      return history.data.url
    }
    case ExtendedSmartSearchEntityType.EVENTS: {
      const event = item as Event
      return event.relativeUrl
    }
    default: {
      const _exhaustiveCheck: never = entityType
      return _exhaustiveCheck
    }
  }
}
